export default x => typeof x === 'object' && x.constructor === Object;
